// extracted by mini-css-extract-plugin
export default {"projectEconomyButton":"ProjectEconomyButton_projectEconomyButton__LNfYj"};